<!--
 * @Descripttion: 备忘提醒 - 新建/编辑备忘窗口页（Electron独立子窗口 / Web独立页面）
 * @version:
 * @Author: geory
 * @Date: 2026-08-14 19:00:00
 * @LastEditors: geory
 * @LastEditTime: 2026-08-14 19:00:00
-->
<template>
    <div class="memoEditWindow">
        <menubar from="memoEdit" />
        <memo-edit :memoData="memoData" :topOffset="topOffset" @close="handleClose" @saved="handleSaved" />
    </div>
</template>

<script>
    import menubar from '@/components/menubar'
    import memoEdit from '@/components/MemoEdit'

    export default {
        name: "MemoEditWindow",
        components: {
            menubar,
            memoEdit
        },
        data() {
            return {
                memoData: null,
            }
        },
        computed: {
            isElectron() {
                return this.$common.isElectron();
            },
            //Electron下顶部有32px窗口控制栏，内容往下偏移
            topOffset() {
                return this.isElectron ? 32 : 0;
            }
        },
        methods: {
            handleClose() {
                if (this.isElectron && window.require) {
                    const {
                        ipcRenderer
                    } = window.require('electron');
                    ipcRenderer.send('closeMemoEdit');
                } else {
                    this.$router.back();
                }
            },
            handleSaved() {
                if (this.isElectron && window.require) {
                    const {
                        ipcRenderer
                    } = window.require('electron');
                    //通知主窗口刷新备忘列表，并关闭本窗口
                    ipcRenderer.send('memoSaved');
                    ipcRenderer.send('closeMemoEdit');
                } else {
                    this.$router.back();
                }
            },
        },
        created() {
            if (this.isElectron && window.require) {
                const {
                    ipcRenderer
                } = window.require('electron');
                //挂载后主动拉取待编辑数据（避免页面懒加载时序导致推送丢失、编辑内容没带进来）
                ipcRenderer.invoke('memoEditGetData').then((data) => {
                    if (data != null) {
                        this.memoData = data;
                    }
                }).catch((e) => {
                    console.log("memoEditGetData error:", e);
                });
                //窗口已加载后再次打开时，主进程会直接推送数据
                //兼容对象与字符串两种载荷
                ipcRenderer.on('memoInfo', (event, payload) => {
                    let info = payload;
                    if (typeof payload === 'string') {
                        try {
                            info = JSON.parse(payload);
                        } catch (e) {
                            info = null;
                        }
                    }
                    this.memoData = (info && info.memoData) || null;
                });
            } else if (this.$route.query.memoData) {
                try {
                    this.memoData = JSON.parse(decodeURIComponent(this.$route.query.memoData)) || null;
                } catch (e) {
                    this.memoData = null;
                }
            }
        },
    }
</script>

<style scoped>
    .memoEditWindow {
        width: 100%;
        height: 100%;
    }
</style>
